import React from 'react';
import type { FunctionComponent } from 'react';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import type { RouteProps } from 'react-router-dom';
import { Redirect, Route, Switch } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Logout from '../pages/Logout';
import Reports from '../pages/Reports/Reports';
import SchoolReports from '../pages/Reports/SchoolReports';
import LessonHistory from '../pages/LessonHistory/LessonHistory';
import TopicFocus from '../pages/TopicFocus/TopicFocus';
import Messages from '../pages/Messages/Messages';
import ResetAssessments from '../pages/ResetAssessments/ResetAssessments';
import RosterManagementRoutes from '../pages/RosterManagement/Routes';
import PasswordInitialisation from '../pages/RosterManagement/pages/PasswordInitialisation/PasswordInitialisation';
import { ROUTES } from '../util/vars';
import PdfBuilder from '../pages/PdfBuilder/PdfBuilder';
import ParentEmailRoutes from '../pages/ParentEmail/Routes';
import { useIdentity } from '@whizz/react-identity';
import AdminRoutes from '../pages/Admin/Routes';
import StudentUploadPage from '../pages/RosterManagement/pages/Upload/StudentUploadPage';

interface AdminOnlyProps extends RouteProps {
  children: React.ReactNode;
}
const AdminOnlyRoute = ({ children, ...rest }: AdminOnlyProps ) => {
  const { me } = useIdentity();
  return (
    <Route {...rest} render={() => (
      !(me as Teacher).getIsAdmin() ? <Redirect to={ROUTES.home} /> : children
    )} />
  );
};

const Routes: FunctionComponent = () => {
  return (
    <Switch>
      <Route path={ROUTES.logout}>
        <Logout />
      </Route>
      <Route path={ROUTES.reports}>
        <Reports />
      </Route>
      <AdminOnlyRoute path={ROUTES.school_reports}>
        <SchoolReports />
      </AdminOnlyRoute>
      <Route path={ROUTES.lesson_history}>
        <LessonHistory />
      </Route>
      <Route path={ROUTES.topic_focus}>
        <TopicFocus />
      </Route>
      <Route path={ROUTES.messages}>
        <Messages />
      </Route>
      <Route path={ROUTES.reset_assessments}>
        <ResetAssessments />
      </Route>
      <Route path={ROUTES.pdf}>
        <PdfBuilder />
      </Route>
      <AdminOnlyRoute path={ROUTES.roster_management}>
        <RosterManagementRoutes />
      </AdminOnlyRoute>
      <Route path={ROUTES.password_initialisation}>
        <PasswordInitialisation />
      </Route>
      <Route path={ROUTES.parent_email}>
        <ParentEmailRoutes />
      </Route>
      <Route path={ROUTES.superAdmin}>
        <AdminRoutes />
      </Route>
      <Route path={ROUTES.home}>
        <Home />
      </Route>
    </Switch>
  );
};

export default Routes;
